import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CatalogPage } from "@insite/client-framework/Services/CategoryService";
import {
    GetProductCollectionApiV2Parameter,
    ProductExpandTokens,
} from "@insite/client-framework/Services/ProductServiceV2";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, DispatchBeginLoadProducts, PrepageProductRecs } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";



interface Parameter {
    queryString?: string;
    path: string;
    isSearch: boolean;
    relevancy?: boolean;
}

export interface DisplayProductsResult {
    products?: ProductModel[];
    productInfosByProductId: SafeDictionary<ProductInfo>;
    productFilters: ProductFilters;
    isFiltered: boolean;
    unfilteredApiParameter?: GetProductCollectionApiV2Parameter;
    filteredApiParameter?: GetProductCollectionApiV2Parameter;
    catalogPage?: CatalogPage;
}
interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
    filterQueryAtRequestStart?: string;
}
type HandlerType = Handler<Parameter, Props>;

export const CustomDispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductList/BeginLoadProducts",
    });
    props.filterQueryAtRequestStart = props.getState().pages.productList.filterQuery;
};
export const DispatchSetProductFiltersUpdated: HandlerType = props => {
    const state = props.getState();
    const filterQuery = state.pages.productList.filterQuery;

    // A request can finish after the user has changed or cleared filters. That
    // newer query is authoritative and must be allowed to update the URL after
    // loading instead of being replaced with the request's stale location.
    if (filterQuery !== props.filterQueryAtRequestStart) {
        return;
    }

    const locationQuery = getLocation(state).search.replace(/^\?/, "");
    if (filterQuery !== locationQuery) {
        props.dispatch({
            type: "Pages/ProductList/SetFilterQuery",
            result: locationQuery,
        });
    }
};

replaceInChain(chain, DispatchBeginLoadProducts, CustomDispatchBeginLoadProducts);
addToChainAfter(chain, PrepageProductRecs, DispatchSetProductFiltersUpdated);